/*
 * @Author: your name
 * @Date: 2021-05-25 09:32:21
 * @LastEditTime: 2021-05-31 18:48:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\request\http.js
 */
// 在http.js中引入axios
import axios from 'axios' // 引入axios
import QS from 'qs' // 引入qs模块，用来序列化post类型的数据，后面会提到
// 先导入vuex,因为我们要使用到里面的状态对象
// vuex的路径根据自己的路径去写
import store from '@/store/index'
import weui from 'weui.js'

/** 创建axios实例 */
const service = axios.create({
  // api的base_url
  baseURL: process.env.BASE_API,
  // 请求超时时间
  timeout: 2000000
})
service.interceptors.response.use(
  (response) => {
    const code = response.status
    if (code < 200 || code > 300) {
      return Promise.reject('error')
    } else if (code === 200) {
      // weui.alert(JSON.stringify(response.data), { title: '错误' })
      let responseEntity = response.data
      if (responseEntity.statusCode === 500) {
        // router.push({ path: '/401' })
        return response
      }
      return response
    } else {
      weui.alert(response.data.message, { title: '错误' })
      return response.data
    }
  },
  error => {
    return Promise.error(error)
  })
// axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = store.state.wechatWebToken
    // const openid = store.state.openid
    // const token = '5d692a3a-aa0f-4aa9-938c-152320b695e3'
    // const openid = '9927'
    token && (config.headers.Authorization = token)
    // token && (config.headers.openid = openid)
    return config
  },
  error => {
    return Promise.error(error)
  })
export default service




// WEBPACK FOOTER //
// ./src/request/request.js